import React from 'react';

const Hero = ({ onWatchClick }) => {
  const handleWatchClick = () => {
    console.log('Watch button clicked');
    if (onWatchClick) {
      onWatchClick();
    } else {
      console.log('onWatchClick prop is not provided');
    }
  };

  return (
    <section
      className="relative bg-cover bg-center text-white section-padding font-display"
      style={{ backgroundImage: "url('/assets/hero-image.jpg')" }}
    >
      <div className="absolute inset-0 bg-ink/70"></div>

      <div className="relative z-10 container mx-auto px-6 py-20 flex flex-col lg:flex-row items-center justify-between gap-12">
        {/* Text Content */}
        <div className="max-w-2xl space-y-6">
          <h1 className="text-4xl lg:text-6xl font-display font-bold leading-tight">
            Stream the Best of US Sports
            <span className="block text-gradient">Anytime. Anywhere.</span>
          </h1>

          <p className="text-lg lg:text-xl text-gray-200">
            IBT Sports brings you official, licensed streaming of the NFL, NBA, and NHL across America and Europe. Enjoy 24/7 HD coverage on all your devices.
          </p>


          {/* Trust Badges */}
          <div className="pt-8">
            <p className="text-sm text-gray-300 mb-2">Officially Licensed by:</p>
            <div className="flex gap-4 items-center">
              <img src="/assets/nfl_sm.png" alt="NFL" className="h-8 w-auto" />
              <img src="/assets/nba_sm.png" alt="NBA" className="h-8 w-auto" />
              <img src="/assets/nhl_sm.png" alt="NHL" className="h-8 w-auto" />
            </div>
            
          </div>
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-2 gap-8 text-center max-w-sm w-full">
          {[
            { label: 'Live Coverage', value: '24/7' },
            { label: 'HD Quality', value: '4K' },
            { label: 'Countries', value: '50+' },
            { label: 'Licensed', value: '100%' },
          ].map(({ label, value }, idx) => (
            <div key={idx} className="space-y-1 card-surface p-4">
              <div className="text-3xl font-bold text-white">{value}</div>
              <div className="text-gray-300 text-sm">{label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
